import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import chatIcon from '../../assets/icons/chat-white.svg'
import {useLocation, useSearchParams} from "react-router-dom";
import useFunction from "../../hooks/useFunction";
import Messages from "../Messages/Messages";

const ChatWindow = () => {

  const {objIsEmpty} = useFunction()
  const [showChat, setShowChat] = useState(false)
  const {user} = useContext(AuthContext)
  const [searchParams, setSearchParams] = useSearchParams()

  // Open chat and restore guest_token from email link
  useEffect(() => {
    const guestChatToken = searchParams.get('guest_chat')
    if (guestChatToken) {
      localStorage.setItem('guest_token', guestChatToken)
      setShowChat(true)
      searchParams.delete('guest_chat')
      setSearchParams(searchParams, {replace: true})
    }
  }, [])

  const handleClick = () => {
    setShowChat(!showChat)
  }
  const location = useLocation();

  if (location.pathname.startsWith('/user/berichten')){
    return (<></>)
  }

  return (
    <div className={(showChat) ? 'component-chat-window open' : 'component-chat-window'}>
      {showChat ?
        <div className="chat-window">
          <div
            className="close"
            onClick={handleClick}
          >&#10005;</div>
          {objIsEmpty(user)
            ?
            <Messages guestMode={true} />
            :
            <Messages
              fixedConversation={1}
            />
          }
        </div>
        :
        <div
          className="show-chat-button"
          onClick={handleClick}
        >
          <img src={chatIcon} alt={"Chat icon"}/>
        </div>
      }
    </div>
  )
}

export default ChatWindow
